import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const ObtenerListaIndicadorDtService = async (values) => {
    try {
        return await instance.Backend.post("/Indicador/ListaIndicadorDt", values, customConfig);
    } catch (error) {
        console.log(error);
    }
}
export { ObtenerListaIndicadorDtService };